<template>
  <v-container fluid>
    <PageTitle title="Files" />

    <FileDataTable
      :show-close="false"
      :show-select="false"
      @select="selectFile"
      @close="close"
      :can-upload="true"
      :can-delete="true"
      :can-remove-token="true"
      :canShare="true"
      :show-download="true"
    />
  </v-container>
</template>

<script>
import FileDataTable from "../ui/shared/FileDataTable.vue";
import PageTitle from "../ui/shared/PageTitle.vue";

export default {
  name: "Files",

  components: { FileDataTable, PageTitle },

  methods: {
    selectFile(filename) {
      console.log(filename);
    },
    close() {
      console.log("close");
    },
  },
};
</script>